import type { IconProps } from './types';

export const Twitter = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
    <path
      d="M15.75 0.000976562H18.8175L12.1175 8.4727L20 20.001H13.8287L8.995 13.0079L3.46375 20.001H0.395L7.56125 10.9389L0 0.000976562H6.32875L10.6975 6.39132L15.75 0.000976562ZM14.675 17.9706H16.375L5.40375 1.92511H3.58125L14.675 17.9706Z"
      fill="var(--color-quanta-icon)"
    />
  </svg>
);
